/* eslint-disable */
import 'regenerator-runtime/runtime'
import '../../polyfills/array.prototype.includes'
import '../../polyfills/array.prototype.find'
import Promise from 'promise-polyfill'

if (!window.Promise) {
  window.Promise = Promise
}



// WEBPACK FOOTER //
// ./src/client/widgets/livepoll/polyfills.js